// extracted by mini-css-extract-plugin
module.exports = {"content-wrapper":"home-carousel-m__content-wrapper__2ZmeD","content":"home-carousel-m__content__XnEAG","description":"home-carousel-m__description__3SmXl"};